import Command from './command';
import { teamBadgeIcon } from '@/views/settings/teams/teamIcon';

class SwitchTeams extends Command {
  id = 'switchTeams';
  icon = 'group_work';
  fontIcon = true;
  title = 'Switch Team';

  async run() {
    let vm = this.vm;
    vm.parentCommand = this;
    vm.searchQuery = '';
    vm.searchPlaceholder = this.title;
    vm.modalTitle = this.title;
    // The searchQuery watcher won't fire if the query was already empty.
    this.addTeams();
  }

  if() {
    return this.vm.currentUser && this.vm.currentUser?.features?.teams;
  }

  asParent() {
    let search = this.vm.searchQuery.trim();
    this.addTeams();
  }

  addTeams() {
    let vm = this.vm;
    //remove previous
    let commands = vm.commands.filter((existing) => {
      return existing.pid !== this.id;
    });

    const teams = this.vm.$store.getters['teams/all'];

    teams.forEach((team) => {
      let cmd = new Command({
        title: team.label,
        id: `team-${team.id}`,
        pid: this.id,
        badge: { icon: teamBadgeIcon(team), color: team.color },
        run: () => {
          this.vm.$store.dispatch('users/updateUserTeam', team?.id);

          setTimeout(() => {
            this.vm.$store.dispatch('teams/safeReload');
          });
          return true;
        },
      });

      cmd.setVM(vm);
      commands.push(cmd);
    });

    vm.commands = commands;
  }
}

export default SwitchTeams;
